import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router";
import { Container, Link, useTheme } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Button from "@mui/material/Button";
import logo from "../assets/logo.png";
import { useTranslation } from "react-i18next";
import { ChangeLanguage } from "./changeLanguage";
import { useAuth } from "../providers/AuthenticationProvider";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Header() {
	const navigate = useNavigate();
	const theme = useTheme();
	const { t } = useTranslation();
	const { profile, traderProfile } = useAuth();
	const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

	const toggleDrawer = () => {
		setIsDrawerOpen(!isDrawerOpen);
	};

	let links = [];
	if (profile == null) {
		const downloadNowElement = (
			
			<Button
				variant="contained"
				color="secondary"
				onClick={() => navigate("signup")}
				sx={{
					fontFamily: "Work Sans !important",
					textTransform: "none",
					fontWeight: "700",
					borderRadius: "100px",
					fontSize: "16px",
					width: { xs: "100%", sm: "unset" },
					marginLeft: window.innerWidth > 600 ? "24px" : "auto",
				}}
			>
				{t("header.startNow")}
			</Button>
		);
		links = [
			{ label: t("header.becomeATrader"), path: "/signup" },
			{ label: t("header.downloadNow"), path: "/home" },
			{ label: t("header.login"), path: "/login" },
			{ label: "", path: "", element: downloadNowElement },
		];
	} else {
		const downloadNowElement = (
			<Button
				variant="contained"
				color="secondary"
				sx={{
					fontFamily: "Work Sans !important",
					textTransform: "none",
					fontWeight: "700",
					borderRadius: "100px",
					fontSize: "16px",
					width: { xs: "100%", sm: "unset" },
					marginLeft: window.innerWidth > 600 ? "24px" : "auto",
				}}
				onClick={() => {
					navigate("/reserved/dashboard");
				}}
			>
				{t("header.upgrade")}
			</Button>
		);

		links = [
			{
				label: t("header.affiliate"),
				path:
					profile.role == "Affiliate"
						? "/affiliate/dashboard"
						: "/reserved/become-affiliate",
			},
			{
				label: t("header.trader"),
				path:
					traderProfile != null
						? "/trader/profile"
						: "/reserved/become-trader",
			},
			{ label: "", path: "", element: downloadNowElement },
		];
	}

	const renderMenuLinks = (
		<>
			<List>
				<ListItem>
					<img
						src={logo}
						loading="lazy"
						style={{ marginTop: "-12px", marginRight: "48px" }}
						width="125px"
						height="40px"
					/>
				</ListItem>
				{links.map((link, index) => {
					return (
						<>
							{link.element != null ? (
								<ListItem key={index}>{link.element}</ListItem>
							) : (
								<ListItem
									key={link.label}
									onClick={() => {
										navigate(link.path);
										toggleDrawer();
									}}
								>
									<ListItemText
										primary={link.label}
										sx={{
											fontFamily: "Work Sans !important",
											fontWeight: "500",
											fontSize: "16px",
										}}
									/>
								</ListItem>
							)}
						</>
					);
				})}
			</List>
			<Container
				sx={{
					flex: 1,
					display: "flex",
					justifyContent: "flex-end",
					flexDirection: "column",
					paddingBottom: "16px",
				}}
			>
				<ChangeLanguage />
			</Container>
		</>
	);

	return (
		<>
			<AppBar
				position="fixed"
				sx={{
					flexGrow: 1,
					zIndex: theme.zIndex.modal + 2,
					boxShadow: "none",
					background: { xs: "transparent", md: "transparent" },
					right: { xs: "16px", md: "0px" },
				}}
			>
				<Toolbar
					sx={{
						padding: 0,
						width: "100%",
						background:
							window.innerWidth > 600 ? "#121721" : "transparent",
					}}
				>
					<img
						src={logo}
						loading="lazy"
						style={{
							marginTop: window.innerWidth > 600 ? "-4px" : "0",
							cursor: "pointer",
							marginLeft: window.innerWidth > 600 ? "" : "28px",
							display: window.innerWidth > 600 ? "block" : "none",
						}}
						onClick={() => {
							navigate("/");
						}}
						width={window.innerWidth > 600 ? "122px" : "90px"}
						height="auto"
					/>

					<Box
						sx={{
							display: { xs: "none", md: "flex" },
							justifyContent: "flex-end",
							alignItems: "center",
							background: "#121721",
							width: "100%",
							padding: "16px",
							borderRadius: "8px",
							gap: "16px",
						}}
					>
						{links.map((link) => {
							return (
								<>
									{link.element != null ? (
										link.element
									) : (
										<Link
											key={link.label}
											color="inherit"
											underline="hover"
											sx={{
												fontFamily:
													"Work Sans !important",
												fontWeight: "700",
												marginLeft: 4,
												fontSize: "16px",
												cursor: "pointer",
											}}
											onClick={() => {
												navigate(link.path);
											}}
										>
											{link.label}
										</Link>
									)}
								</>
							);
						})}
						<Container
							sx={{
								width: "fit-content",
								margin: 0,
							}}
						>
											<LanguageSwitcher />

							{
								//<ChangeLanguage />
							}
						</Container>
					</Box>
					<Box
						sx={{
							ml: "auto",
							display: { xs: "block", md: "none" },
							zIndex: theme.zIndex.modal + 2,
						}}
					>
						<IconButton
							size="large"
							edge="end"
							color="inherit"
							aria-label="menu"
							onClick={toggleDrawer}
							sx={{
								marginLeft: "auto",
								backgroundColor: "#121721",
							}}
						>
							{isDrawerOpen ? <CloseIcon /> : <MenuIcon />}
						</IconButton>
					</Box>
				</Toolbar>
			</AppBar>
			<Drawer
				anchor="right"
				open={isDrawerOpen}
				onClose={toggleDrawer}
				sx={{ zIndex: theme.zIndex.modal + 1 }} // Ensure drawer is on top
			>
				{renderMenuLinks}
			</Drawer>
		</>
	);
}
